/* Self-flowing grid: column count derives from how many cards of
   the configured min tile width fit in the available container.
   No viewport media queries — phones get 1/2 cards, tablets 2/3,
   desktop 3/4/5, all from column-count math. The optional `--min`
   custom property (default 220px) lets a parent tweak tile size. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--min, 220px), 1fr));
  gap: clamp(16px, 2vw, 32px) clamp(8px, 1.5vw, 24px);
  background: #fff;
  container-type: inline-size;
}

/* Portrait-narrow grids — when only ~2 cards fit, tighten column
   gap so the merchandise reads as a centered cluster. */
@container (max-width: 540px) {
  .grid { gap: 18px 8px; }
}
